import { Skeleton } from "antd";
import PaymentSummarySkeleton from "./PaymentSummarySkeleton";
import InsuranceDocumentsSkeleton from "./InsuranceDocumentsSkeleton";
import CustomerProfileSkeleton from "./CustomerProfileSkeleton";
import LifecycleTimelineSkeleton from "./LifecycleTimelineSkeleton";

const OverviewTabSkeleton = () => (
    <div className="grid gap-3 xl:grid-cols-[minmax(0,1fr)_minmax(280px,320px)]">
        <div className="flex min-w-0 flex-col gap-3">
            <PaymentSummarySkeleton />
            <InsuranceDocumentsSkeleton />
        </div>
        <div className="flex min-w-0 flex-col gap-3">
            <CustomerProfileSkeleton />
            <LifecycleTimelineSkeleton />
        </div>
    </div>
);

const TabsSectionSkeleton = () => (
    <div>
        <div className="mb-3 flex gap-6 border-b border-[#f0f0f0] pb-3">
            <Skeleton.Button active size="small" className="!w-20" />
            <Skeleton.Button active size="small" className="!w-32" />
        </div>
        <OverviewTabSkeleton />
    </div>
);

export default TabsSectionSkeleton;
